import { render, staticRenderFns } from "./BankTxListPanel.vue?vue&type=template&id=5e18de93&"
import script from "./BankTxListPanel.vue?vue&type=script&lang=js&"
export * from "./BankTxListPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports